/**
 * PDP sticky CTA — LLP layout, Kaching copy sync, puppet-click main ATC.
 * Shows only after main Add to cart has scrolled past the top of the viewport.
 */
(function () {
  'use strict';

  var inited = new WeakSet();

  function markInited(el) {
    if (!el || inited.has(el)) return false;
    inited.add(el);
    return true;
  }

  function findMoneyAll(text) {
    var matches = String(text || '').match(/(£|\$|€)\s?[\d,.]+/g) || [];
    return matches.map(function (m) {
      return m.replace(/\s+/g, '');
    });
  }

  function moneyValue(str) {
    return parseFloat(String(str || '').replace(/[^\d.]/g, '')) || 0;
  }

  var COMPARE_PRICE_SELECTOR = [
    's',
    'del',
    '[style*="line-through"]',
    '[class*="compare"]',
    '[class*="Compare"]',
    '[class*="full-price"]',
    '[class*="FullPrice"]',
    '[class*="was-price"]',
    '[class*="WasPrice"]',
    '[class*="original-price"]',
    '[class*="strike"]',
    '.kaching-bundles__bar-full-price',
  ].join(', ');

  function hasLineThrough(el) {
    var cur = el;
    for (var i = 0; i < 6 && cur && cur.nodeType === 1; i++) {
      if (cur.matches && cur.matches(COMPARE_PRICE_SELECTOR)) return true;
      try {
        var style = window.getComputedStyle(cur);
        var deco = (style && (style.textDecorationLine || style.textDecoration)) || '';
        if (String(deco).indexOf('line-through') !== -1) return true;
      } catch (err) {}
      cur = cur.parentElement;
    }
    return false;
  }

  function findSalePrices(root) {
    if (!root) return [];
    var found = [];
    var seen = {};
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var matches = String(node.textContent || '').match(/(£|\$|€)\s?[\d,.]+/g);
      if (!matches) continue;
      if (hasLineThrough(node.parentElement)) continue;
      matches.forEach(function (m) {
        var price = m.replace(/\s+/g, '');
        if (!seen[price]) {
          seen[price] = true;
          found.push(price);
        }
      });
    }
    return found;
  }

  function pickLargest(prices) {
    if (!prices || !prices.length) return '';
    return prices.slice().sort(function (a, b) {
      return moneyValue(b) - moneyValue(a);
    })[0];
  }

  function pickFullPackPrice(mount) {
    if (!mount) return '';

    var freqCard = null;
    var freqLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = el.textContent || '';
      if (!/subscribe|one[\s-]?time/i.test(text)) return;
      if (text.length > 600) return;
      var checked =
        el.matches('[aria-checked="true"], [aria-pressed="true"], .selected, .is-selected, [class*="selected"]') ||
        !!el.querySelector('input:checked, [aria-checked="true"]');
      if (!checked) return;
      if (text.length < freqLen) {
        freqLen = text.length;
        freqCard = el;
      }
    });

    if (freqCard) {
      var freqClone = freqCard.cloneNode(true);
      freqClone.querySelectorAll(COMPARE_PRICE_SELECTOR).forEach(function (node) {
        node.remove();
      });
      var freqPrices = findMoneyAll(freqClone.textContent || '');
      var liveSale = findSalePrices(freqCard);
      if (liveSale.length) freqPrices = liveSale;

      if (freqPrices.length === 1) return freqPrices[0];
      if (freqPrices.length === 2) {
        return moneyValue(freqPrices[0]) <= moneyValue(freqPrices[1]) ? freqPrices[0] : freqPrices[1];
      }
      if (freqPrices.length > 2) return pickLargest(freqPrices);
    }

    return pickLargest(findSalePrices(mount));
  }

  function isElSelected(el) {
    if (!el) return false;
    return (
      el.matches(
        '[aria-checked="true"], [aria-pressed="true"], [aria-selected="true"], .selected, .is-selected, [class*="selected"]'
      ) || !!el.querySelector('input:checked, [aria-checked="true"], [aria-selected="true"]')
    );
  }

  function readKachingPackQty(mount, formQty) {
    var found = 0;
    if (mount) {
      mount.querySelectorAll('label, [role="radio"], button, li, div').forEach(function (el) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (text.length > 220) return;
        var buyMatch = text.match(/buy\s+(\d+)\s+packs?/i);
        if (!buyMatch) return;
        if (!isElSelected(el) && !(el.querySelector && el.querySelector('input:checked'))) return;
        found = parseInt(buyMatch[1], 10) || found;
      });

      if (!found) {
        var summary = (mount.textContent || '').match(/(\d+)\s+packs?\s+repeats/i);
        if (summary) found = parseInt(summary[1], 10) || 0;
      }
    }
    return found || formQty || 1;
  }

  function readKachingFrequencyMonths(mount) {
    if (!mount) return 0;

    var months = 0;
    mount.querySelectorAll('select').forEach(function (select) {
      if (months) return;
      var opt = select.options && select.options[select.selectedIndex];
      var label = ((opt && opt.textContent) || select.value || '').replace(/\s+/g, ' ');
      if (!/month/i.test(label)) return;
      var m = label.match(/(\d+)\s*months?/i);
      if (m) months = parseInt(m[1], 10) || 0;
    });
    if (months) return months;

    var best = '';
    var bestLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/subscribe/i.test(text) || !/every\s+\d+\s+months?/i.test(text)) return;
      if (text.length > 600) return;
      if (!isElSelected(el)) return;
      if (text.length < bestLen) {
        bestLen = text.length;
        best = text;
      }
    });

    var match = best.match(/every\s+(\d+)\s+months?/i);
    if (!match) match = (mount.textContent || '').match(/repeats?\s+every\s+(\d+)\s+months?/i);
    return match ? parseInt(match[1], 10) || 0 : 0;
  }

  function readKachingIsSubscribe(mount, sellingPlan) {
    if (!mount) return !!sellingPlan;

    var best = '';
    var bestLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/subscribe|one[\s-]?time/i.test(text)) return;
      if (text.length > 600) return;
      if (!isElSelected(el)) return;
      if (text.length < bestLen) {
        bestLen = text.length;
        best = text;
      }
    });

    if (best) {
      if (/one[\s-]?time/i.test(best) && !/repeats?\s+every/i.test(best)) return false;
      if (/subscribe/i.test(best)) return true;
    }
    return !!sellingPlan;
  }

  function formatStickyPackNote(qty, isSubscribe, months) {
    var packLabel = String(qty || 1) + '-PACK';
    if (!isSubscribe) return packLabel + ' • ONE-TIME';
    if (months) return packLabel + ' • EVERY ' + months + ' MONTHS';
    return packLabel + ' • SUBSCRIPTION';
  }

  function getPurchaseMount() {
    return document.querySelector('#dcoded-pdp-purchase-card') || document.querySelector('[data-dcoded-pdp-atc-target]');
  }

  function getProductForm() {
    var mount = getPurchaseMount();
    if (!mount) return document.querySelector('product-form-component form');
    return (
      mount.querySelector('product-form-component form') ||
      mount.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form-component form')
    );
  }

  function getMainAddToCartButton() {
    var mount = getPurchaseMount();
    var scope = mount || document;
    return (
      scope.querySelector('.buy-buttons-block [ref="addToCartButton"]') ||
      scope.querySelector('product-form-component [ref="addToCartButton"]') ||
      document.querySelector('.buy-buttons-block [ref="addToCartButton"]')
    );
  }

  function getAtcTarget() {
    return getMainAddToCartButton();
  }

  function updateStickyUI(sticky, detail) {
    if (!sticky || !detail) return;
    var priceEl = sticky.querySelector('[data-dcoded-pdp-sticky-price]');
    var unitEl = sticky.querySelector('[data-dcoded-pdp-sticky-unit]');
    var noteEl = sticky.querySelector('[data-dcoded-pdp-sticky-note]');
    var reassureEl = sticky.querySelector('[data-dcoded-pdp-sticky-reassure]');
    var ctaEl = sticky.querySelector('[data-dcoded-pdp-sticky-cta]');

    if (priceEl && detail.pouchPrice) priceEl.textContent = detail.pouchPrice;
    if (unitEl && typeof detail.stickyUnit === 'string') unitEl.textContent = detail.stickyUnit;
    if (noteEl && detail.stickyNote) noteEl.textContent = detail.stickyNote;
    if (reassureEl && detail.reassure) reassureEl.textContent = detail.reassure;
    if (ctaEl && detail.stickyCta) ctaEl.textContent = detail.stickyCta;
  }

  function syncStickyFromKaching(sticky) {
    var form = getProductForm();
    var mount = getPurchaseMount();
    var formQty = parseInt((form && form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    var planEl = form && form.querySelector('[name="selling_plan"]');
    var sellingPlan = planEl && planEl.value ? planEl.value : '';
    var qty = readKachingPackQty(mount, formQty);
    var isSubscribe = readKachingIsSubscribe(mount, sellingPlan);
    var months = isSubscribe ? readKachingFrequencyMonths(mount) : 0;
    var price = pickFullPackPrice(mount);

    updateStickyUI(sticky, {
      quantity: qty,
      sellingPlan: sellingPlan,
      mode: isSubscribe ? 'subscribe' : 'one_time',
      pouchPrice: price || '',
      stickyUnit: '',
      stickyNote: formatStickyPackNote(qty, isSubscribe, months),
      stickyCta: 'Add to cart' + (price ? ' · ' + price : ''),
      reassure: isSubscribe
        ? 'Subscription · cancel anytime · free UK delivery'
        : 'One-time · free UK delivery',
    });
  }

  function initSticky(root) {
    if (!root || !markInited(root)) return;

    var cta = root.querySelector('[data-dcoded-pdp-sticky-cta]');
    var footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    var hiddenByFooter = false;
    var observedTarget = null;
    var atcObserver = null;
    var footerObserver = null;

    function resolveAtcTarget() {
      return getAtcTarget();
    }

    function setVisible(show) {
      root.classList.toggle('is-visible', !!show);
    }

    function syncVisibility() {
      var atcTarget = resolveAtcTarget();
      if (!atcTarget) {
        setVisible(false);
        return;
      }
      var rect = atcTarget.getBoundingClientRect();
      // Only after ATC has scrolled past the top — never while ATC is still below
      var scrolledPastAtc = rect.bottom <= 0;
      setVisible(scrolledPastAtc && !hiddenByFooter);
    }

    function bindAtcObserver() {
      var atcTarget = resolveAtcTarget();
      if (!atcTarget || atcTarget === observedTarget) return;

      if (atcObserver) {
        atcObserver.disconnect();
        atcObserver = null;
      }

      if (typeof IntersectionObserver !== 'undefined') {
        atcObserver = new IntersectionObserver(
          function () {
            syncVisibility();
          },
          { threshold: 0, rootMargin: '0px' }
        );
        atcObserver.observe(atcTarget);
        observedTarget = atcTarget;
      }
    }

    if (typeof IntersectionObserver !== 'undefined' && footer) {
      footerObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          hiddenByFooter = entry.isIntersecting;
          syncVisibility();
        },
        { rootMargin: '200px 0px 0px 0px' }
      );
      footerObserver.observe(footer);
    }

    function onScrollOrResize() {
      bindAtcObserver();
      syncVisibility();
    }

    bindAtcObserver();
    syncVisibility();
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    var mount = getPurchaseMount();
    var form = getProductForm();
    var scheduleTimer = 0;
    function scheduleSync() {
      window.clearTimeout(scheduleTimer);
      scheduleTimer = window.setTimeout(function () {
        bindAtcObserver();
        syncStickyFromKaching(root);
        syncVisibility();
      }, 50);
    }

    if (mount) {
      mount.addEventListener('click', scheduleSync);
      mount.addEventListener('change', scheduleSync);
      ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(function (evt) {
        mount.addEventListener(evt, scheduleSync);
      });

      if (typeof MutationObserver !== 'undefined') {
        var obs = new MutationObserver(scheduleSync);
        obs.observe(mount, { childList: true, subtree: true, attributes: true });
        window.setTimeout(function () {
          obs.disconnect();
        }, 15000);
      }
    }

    if (form) form.addEventListener('change', scheduleSync);

    var tries = 0;
    var boot = window.setInterval(function () {
      tries += 1;
      bindAtcObserver();
      syncStickyFromKaching(root);
      syncVisibility();
      if (tries >= 40) window.clearInterval(boot);
    }, 250);
    scheduleSync();

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (cta.classList.contains('is-loading') || cta.disabled) return;
        var mainBtn = getMainAddToCartButton();
        if (!mainBtn) return;
        cta.classList.add('is-loading');
        cta.setAttribute('aria-disabled', 'true');
        mainBtn.dataset.puppet = 'true';
        mainBtn.click();
        window.setTimeout(function () {
          cta.classList.remove('is-loading');
          cta.removeAttribute('aria-disabled');
          if (mainBtn.dataset) mainBtn.dataset.puppet = 'false';
        }, 1200);
      });
    }

    root._dcodedPdpStickyCleanup = function () {
      if (atcObserver) atcObserver.disconnect();
      if (footerObserver) footerObserver.disconnect();
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
      inited.delete(root);
    };
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dcoded-pdp-sticky]').forEach(initSticky);
    if (root.matches && root.matches('[data-dcoded-pdp-sticky]')) initSticky(root);
  }

  function onSectionLoad(e) {
    var el = e.target;
    if (!el || !el.querySelector) return;
    initAll(el);
  }

  function onSectionUnload(e) {
    var el = e.target;
    if (!el || !el.querySelector) return;
    var sticky = el.querySelector('[data-dcoded-pdp-sticky]');
    if (sticky && typeof sticky._dcodedPdpStickyCleanup === 'function') {
      sticky._dcodedPdpStickyCleanup();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
